import { INBOX_TYPES, TWILIO_CHANNEL_MEDIUM } from 'dashboard/helper/inbox';
import { isWahaApiInbox } from 'dashboard/helper/wahaInbox';

const CHANNEL_KEYS = {
  [INBOX_TYPES.WHATSAPP]: 'WHATSAPP',
  [INBOX_TYPES.WHATSAPP_WEB]: 'WHATSAPP',
  [INBOX_TYPES.FB]: 'MESSENGER',
  [INBOX_TYPES.INSTAGRAM]: 'INSTAGRAM',
  [INBOX_TYPES.TELEGRAM]: 'TELEGRAM',
  [INBOX_TYPES.EMAIL]: 'EMAIL',
  [INBOX_TYPES.WEB]: 'WEB',
  [INBOX_TYPES.TWITTER]: 'TWITTER',
  [INBOX_TYPES.LINE]: 'LINE',
  [INBOX_TYPES.SMS]: 'SMS',
  [INBOX_TYPES.TIKTOK]: 'TIKTOK',
  [INBOX_TYPES.API]: 'API',
};

export function inboxChannelType(inbox) {
  return inbox?.channel_type || inbox?.channelType || '';
}

export function isWhatsAppLikeInbox(inbox) {
  const type = inboxChannelType(inbox);
  if (type === INBOX_TYPES.WHATSAPP || type === INBOX_TYPES.WHATSAPP_WEB) {
    return true;
  }
  if (isWahaApiInbox(inbox)) return true;
  return (
    type === INBOX_TYPES.TWILIO &&
    (inbox?.medium || inbox?.Medium) === TWILIO_CHANNEL_MEDIUM.WHATSAPP
  );
}

export function channelLabelKey(inbox) {
  if (isWhatsAppLikeInbox(inbox)) return 'WHATSAPP';
  return CHANNEL_KEYS[inboxChannelType(inbox)] || 'CHANNEL';
}

export function translateChannelLabel(inbox, t) {
  switch (channelLabelKey(inbox)) {
    case 'WHATSAPP':
      return t('CONVERSATION.HEADER.CHANNELS.WHATSAPP');
    case 'MESSENGER':
      return t('CONVERSATION.HEADER.CHANNELS.MESSENGER');
    case 'INSTAGRAM':
      return t('CONVERSATION.HEADER.CHANNELS.INSTAGRAM');
    case 'TELEGRAM':
      return t('CONVERSATION.HEADER.CHANNELS.TELEGRAM');
    case 'EMAIL':
      return t('CONVERSATION.HEADER.CHANNELS.EMAIL');
    case 'WEB':
      return t('CONVERSATION.HEADER.CHANNELS.WEB');
    case 'TWITTER':
      return t('CONVERSATION.HEADER.CHANNELS.TWITTER');
    case 'LINE':
      return t('CONVERSATION.HEADER.CHANNELS.LINE');
    case 'SMS':
      return t('CONVERSATION.HEADER.CHANNELS.SMS');
    case 'TIKTOK':
      return t('CONVERSATION.HEADER.CHANNELS.TIKTOK');
    case 'API':
      return t('CONVERSATION.HEADER.CHANNELS.API');
    default:
      return t('CONVERSATION.HEADER.CHANNELS.CHANNEL');
  }
}

export function channelBadgeStyle(inbox) {
  if (isWhatsAppLikeInbox(inbox)) {
    return { bgClass: 'bg-[#25d366]', icon: 'i-ri-whatsapp-line' };
  }

  switch (inboxChannelType(inbox)) {
    case INBOX_TYPES.INSTAGRAM:
      return { bgClass: 'bg-[#e4405f]', icon: 'i-ri-instagram-line' };
    case INBOX_TYPES.FB:
      return { bgClass: 'bg-[#0084ff]', icon: 'i-ri-messenger-line' };
    case INBOX_TYPES.TELEGRAM:
      return { bgClass: 'bg-[#229ed9]', icon: 'i-ri-telegram-line' };
    case INBOX_TYPES.EMAIL:
      return { bgClass: 'bg-n-slate-9', icon: 'i-ri-mail-line' };
    case INBOX_TYPES.TIKTOK:
      return { bgClass: 'bg-n-slate-12', icon: 'i-ri-tiktok-line' };
    default:
      return { bgClass: 'bg-n-slate-9', icon: 'i-ri-chat-1-line' };
  }
}
